import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setBasicFilters } from '@/redux/store/actions/search';
import CalenderDates from '@/components/reusable/searchDatePicker/calenderDates/CalenderDates';
import FooterDescription from '@/components/datepicker/instanstDescriptions/InstanstPeakDescription';
import { CalendarPricingType } from '@/components/houses/_hooks/useProduct';
import HouseDatePickerMulti from '../../../../datepicker/multiRangeDatepicker/MultiDatepicker';
import DatePickerDescription from '@/components/houses/_reusable/datePickerDescription/DatePickerDescription';
import { useMidTermQuery } from '@/components/houses/_hooks/useMidterm';
import Box from '@/components/UI/box/Box';
import styles from './CalendarModal.module.scss';
import { ProductItemTypes } from '@/components/houses/_types/productItem.types';
type TCalenderPricing = {
  calendarPricing: CalendarPricingType;
  isShowModal: boolean;
  setIsShowModal: (arg: boolean) => void;
  minDays?: number;
  productData?: ProductItemTypes;
};
const CalendarModal = ({
  calendarPricing,
  isShowModal,
  setIsShowModal,
  minDays,
  productData
}: TCalenderPricing) => {
  const {
    isMidTerm
  } = useMidTermQuery(productData);
  const {
    handleMultiCalendarChange,
    houseCalendarData
  } = calendarPricing;
  const calendarRef = React.useRef<any>(null);
  const ref = React.useRef<HTMLDivElement>(null);
  const {
    checkin,
    checkout,
    guests
  } = useSelector(state => state.basicFilters);
  const dispatch = useDispatch();
  React.useEffect(() => {
    isShowModal && !!checkin && !!checkout && setIsShowModal(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkin, checkout]);
  React.useEffect(() => {
    function handleClickOutside(event: MouseEvent): void {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setIsShowModal(false);
      }
    }

    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });
  const handleChange = ({
    checkin,
    checkout
  }) => {
    dispatch(setBasicFilters({
      checkin,
      checkout,
      guests
    }));
  };
  const cleanCheckout = () => {
    calendarRef.current?.cleanCheckout();
    dispatch(setBasicFilters({
      checkin,
      checkout: null,
      guests
    }));
  };
  const cleanCheckIn = () => {
    calendarRef.current?.cleanValue();
    dispatch(setBasicFilters({
      checkin: null,
      checkout: null,
      guests
    }));
  };
  return isShowModal && <Box className={styles['calendar-modal']} ref={ref}>
        <Box className={styles['calendar-modal-header']}>
          <Box className={styles['calendar-modal-header-date']}>
            <CalenderDates checkin={checkin} checkout={checkout} clearable cleanCheckIn={cleanCheckIn} cleanCheckout={cleanCheckout} rounded />
          </Box>
          <Box className={styles['calendar-modal-header-info']}>
            {!isMidTerm ? <FooterDescription fullText /> : <DatePickerDescription mid_term_minimum_days={productData?.pricing?.records?.[0]?.mid_term_minimum_days} />}
          </Box>
        </Box>
        <Box>
          {houseCalendarData && <HouseDatePickerMulti dateRef={calendarRef} dates={{
        checkin,
        checkout
      }} onChange={handleChange} dateType={'JALALI'} hasCalendar isFull={!isMidTerm} calendar={houseCalendarData.calendar} endDay={houseCalendarData.endDay} nextRangeMonths={houseCalendarData.differenceInDays || 90} getCalendarFunc={handleMultiCalendarChange} minDays={isMidTerm && minDays} withTooltip />}
        </Box>
      </Box>;
};
export default CalendarModal;